import { OnlineBookingModel } from "../../modules/online-booking/models";

export const formatLinkDisplay = (cell: OnlineBookingModel) => {
    const linkDefault = `${window.location.origin}/booking`;
    if (cell.isDefault) {
      return linkDefault;
    }
    return `${linkDefault}/${cell.shortId}`;
  }